export default "__VITE_ASSET__BfEz6x6p__"